import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const previousPathname = useRef<string>('');

  useEffect(() => {
    const currentPath = pathname;
    const prevPath = previousPathname.current;
    
    // Don't scroll to top when:
    // 1. Going back to home from a product page
    // 2. Going back to products from a product page
    const isNavigatingBackToHome = currentPath === '/' && prevPath.startsWith('/products/');
    const isNavigatingBackToProducts = currentPath === '/products' && prevPath.startsWith('/products/');
    
    if (!isNavigatingBackToHome && !isNavigatingBackToProducts) {
      // Add a small delay to ensure content is loaded
      const timeoutId = setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);

      // Store the current pathname for next comparison
      previousPathname.current = currentPath;

      // Cleanup timeout on unmount or route change
      return () => clearTimeout(timeoutId);
    } else {
      // Just update the previous pathname without scrolling
      previousPathname.current = currentPath;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop; 